import { gql } from '@apollo/client';
import THREAD_FIELDS_FRAGMENT from './fragments/ThreadFields';

const UNRESOLVE_THREAD_MUTATION = gql`
  mutation unresolveThread($id: ID!) {
    unresolveThread(threadId: $id) {
      ...ThreadFields
    }
  }
  ${THREAD_FIELDS_FRAGMENT}
`;

export default UNRESOLVE_THREAD_MUTATION;
